module.exports = __webpack_public_path__ + "static/img/news0925a.e55855d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/news0925a.jpg
// module id = 2Bmo
// module chunks = 1